import { render, staticRenderFns } from "./DonutChart16.vue?vue&type=template&id=0f84e007&scoped=true"
import script from "./DonutChart16.vue?vue&type=script&lang=js"
export * from "./DonutChart16.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f84e007",
  null
  
)

export default component.exports